import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsDefinedNotEmptyPipe } from '@softline/ui-core';
import { Palette } from '@softapps/lager/core';

@Component({
  selector: 'soft-picking-pallet',
  imports: [CommonModule, IsDefinedNotEmptyPipe],
  templateUrl: './picking-pallet.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './picking-pallet.component.css',
})
export class PickingPalletComponent {
  number = input.required<number>();
  palletInput = input.required<Palette>({alias: 'pallet'});
}
